exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".send-email-box .input_box {\n  display: flex;\n  flex-direction: row;\n}\n.send-email-box .input_box .lable {\n  padding-top: 12px;\n  padding-right: 6px;\n  color: red;\n}\n.send-email-box .ref_input {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.send-email-box .pop-btn {\n  display: flex;\n  flex-direction: row-reverse;\n}\n.send-email-box .pop-btn .cancel-btn {\n  margin-left: 10px;\n}\n", ""]);

// exports
